<template>
  <div class="bracelet">
    <section class="section1 container">
      <img class="wave-top" src="@/assets/img/wave_top_page.png" />
      <img class="wave-top-mobile" src="@/assets/img/wave_top_mobile.png" />
      <h2 class="section-title">Upmood Bracelet</h2>
      <img
        class="upmood-band-real"
        src="@/assets/img/upmood_band_real1.png"
        v-show="upmoodReal"
      />
      <img
        class="upmood-band-real"
        src="@/assets/img/upmood_band_real2.png"
        v-show="!upmoodReal"
      />
      <div class="upmood-band-small-wrapper">
        <img
          class="upmood-band-small"
          src="@/assets/img/upmood_band_real_small1.png"
          @click="upmoodReal = true"
        />
        <img
          class="upmood-band-small"
          src="@/assets/img/upmood_band_real_small2.png"
          @click="upmoodReal = false"
        />
      </div>
      <div class="circle-blue animate-growing"></div>
      <div class="circle-light-yellow circle1 animate-shrinking"></div>
      <div class="circle-yellow circle2 animate-shrinking"></div>
    </section>
    <section class="section2 container">
      <div class="specs">
        <h4 class="subtitle">Specifications and Support</h4>
        <div class="col-wrapper">
          <div class="col">
            General Specs
            <ul>
              <li>Compatible with all IOS and Android devices</li>
              <li>Bluetooth Connectivity</li>
              <li>PPG Sensor</li>
            </ul>
          </div>
          <div class="col">
            Strap
            <ul>
              <li>Interchangeable polyester Strap</li>
              <li>Adjustable size: 1in to 9in (diameter)</li>
            </ul>
          </div>
          <div class="col">
            Battery
            <ul>
              <li>Battery: Li-polymer battery</li>
              <li>Standby time: 48 hours</li>
              <li>Always on time: 12 hours</li>
              <li>Time to charge: 1 hour</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="video-section container">
      <video controls>
        <source src="@/assets/video/upmoodspecs.mp4" type="video/mp4" />
      </video>
    </section>

    <section class="section3 container">
      <h4 class="subtitle">Upmood Strap</h4>
      <p class="description">
        Choose a strap that fits your mood with our assortment of lightweight,
        highly-durable polyester strap that comes in black and exclusive Upmood
        colors -- sea green and bright yellow.
      </p>
      <div class="colors-wrapper">
        <div
          class="color"
          :class="{ active: activePicker == 0 }"
          @click="changeBandColor(0)"
        >
          <span></span>
        </div>
        <div
          class="color"
          :class="{ active: activePicker == 1 }"
          @click="changeBandColor(1)"
        >
          <span></span>
        </div>
        <div
          class="color"
          :class="{ active: activePicker == 2 }"
          @click="changeBandColor(2)"
        >
          <span></span>
        </div>
      </div>
      <div class="band3d">
        <upmoodBand
          ref="bracelet_band"
          :options="upmoodBandOption1"
        ></upmoodBand>
      </div>
      <div class="circle-light-yellow circle1 animate-growing"></div>
      <div class="circle-light-yellow circle2 animate-shrinking"></div>
      <div class="circle-orange animate-shrinking"></div>
    </section>
    <section class="section4 container">
      <div class="band3d">
        <upmoodBand
          ref="bracelet_tech"
          :options="upmoodBandOption2"
        ></upmoodBand>
      </div>
      <div class="description-card desc1">
        <h3 class="description-title">Upmood Technology</h3>
        <p class="description">
          The algorithm Upmood uses can turn every data collected from your
          pulse waves into analytics through bluetooth connection to the app to
          let you know of your stress level, heart rate, vitality levels, and
          emotion.
        </p>
      </div>
      <div class="description-card desc2">
        <h3 class="description-title">It starts with a beat</h3>
        <p class="description">
          Upmood journey starts with a single beat. Through the PPG Sensor, we
          can collect biodata from your heart rate and contractions using only
          one wrist for an unprecedented level of accuracy.
        </p>
      </div>
      <div class="big-circle inner"></div>
      <div class="big-circle outer"></div>
      <div class="small-circles animate-rotating">
        <div class="circle-blue circle1"></div>
        <div class="circle-blue circle2"></div>
        <div class="circle-blue circle3"></div>
        <div class="circle-blue circle4"></div>
        <div class="circle-cyan circle1">
          <div class="circle-cyan"></div>
        </div>
        <div class="circle-cyan circle2">
          <div class="circle-cyan"></div>
        </div>
      </div>
      <div class="circle-light-yellow animate-shrinking"></div>

      <img
        class="wave-bottom animate-floating"
        src="@/assets/img/wave_bottom_page.png"
      />
    </section>
  </div>
</template>
<script>
import upmoodBand from "@/components/UpmoodBand";

export default {
  data() {
    return {
      activePicker: 0,
      upmoodReal: false,
      upmoodBandOption1: {
        rotate: true,
        rotationX: 0.02,
        rotationY: -0.7,
        rotationZ: -0.1
      },

      upmoodBandOption2: {
        rotate: false,
        rotationX: 0,
        rotationY: 0,
        rotationZ: 0,
        limitAngle: true,
        minPolar: Math.PI / 2,
        maxPolar: Math.PI / 1.8,
        minAzimuth: -0.1,
        maxAzimuth: 0.1
      }
    };
  },

  components: {
    upmoodBand
  },

  mounted() {
    this.loadBands();
  },

  activated() {
    this.$refs.bracelet_band.animate();
    this.$refs.bracelet_tech.animate();
  },

  deactivated() {
    this.$refs.bracelet_band.stop();
    this.$refs.bracelet_tech.stop();
  },

  methods: {
    changeBandColor(color) {
      this.$refs.bracelet_band.changeColor(color);
      this.activePicker = color;
    },

    async loadBands() {
      var vue = this;
      await this.$refs.bracelet_band.load();

      vue.$refs.bracelet_tech.load();
    }
  }
};
</script>
<style lang="scss" scoped>
.bracelet {
  .section1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    margin-bottom: 100px;
    margin-top: 180px;

    .wave-top {
      position: absolute;
      display: block;
      top: -240px;
      width: 115%;
      right: -325px;

      @include mobile {
        display: none;
      }
    }

    .wave-top-mobile {
      display: none;

      @include mobile {
        position: absolute;
        top: -200px;
        width: 115%;
        height: 100px;
        display: block;
      }
    }

    .upmood-band-real {
      height: 433px;
      margin-top: 50px;
      z-index: +1;

      @include mobile {
        height: 160px;
        margin: 50px auto 70px auto;
      }
    }

    .upmood-band-small-wrapper {
      width: 95px;
      height: 195px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: absolute;
      bottom: 0;
      left: 100px;
      z-index: +1;

      @include mobile {
        align-self: flex-start;
        position: relative;
        flex-direction: row;
        justify-content: flex-start;
        height: 60px;
        width: 100px;
        left: 0;
      }

      .upmood-band-small {
        width: 100%;
        cursor: pointer;

        @include mobile {
          width: 60px;
          margin-left: 10px;
        }
      }
    }

    .circle-blue {
      height: 183px;
      width: 183px;
      position: absolute;
      top: 0;
      left: -100px;

      @include mobile {
        height: 50px;
        width: 50px;
        top: -80px;
        left: -20px;
      }
    }

    .circle1 {
      position: absolute;
      height: 118px;
      width: 118px;
      top: -165px;
      left: 225px;

      @include mobile {
        height: 50px;
        width: 50px;
        top: -115px;
        left: 110px;
      }
    }

    .circle2 {
      position: absolute;
      height: 315px;
      width: 315px;
      right: -220px;
      bottom: -100px;

      @include mobile {
        height: 150px;
        width: 150px;
        right: -75px;
        bottom: 0px;
      }
    }
  }

  .section2 {
    margin-bottom: 100px;

    .specs {
      height: 331px;
      width: 100%;
      border: 1px solid $color9;
      border-radius: 4px;
      background-color: #ffffff;
      box-shadow: 0 35px 39px -9px rgba(231, 231, 231, 0.5);
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px 50px;
      z-index: +1;

      @include mobile {
        width: 100%;
        padding: 30px;
        height: auto;
      }

      .col-wrapper {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin-top: 50px;

        @include mobile {
          flex-direction: column;
          margin-top: 20px;
        }

        .col {
          width: 210px;
          color: #91aaaa;
          font-family: $Lato;
          font-size: 16px;
          line-height: 19px;

          @include mobile {
            margin-bottom: 20px;
          }

          ul {
            list-style: none;
            width: 100%;
            border-top: 1px solid #91aaaa;
            margin-top: 10px;

            li {
              margin: 15px 0;
            }
          }
        }
      }
    }
  }

  .video-section {
    margin-bottom: 100px;
    display: flex;
    justify-content: center;

    video {
      width: auto;
      height: 500px;
      border: 1px solid $color9;

      @include mobile {
        width: 100%;
        height: auto;
      }
    }
  }

  .section3 {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 100px;
    position: relative;

    .description {
      width: 640px;
      font-size: 18px;
      text-align: center;
      margin-top: 30px;
      line-height: 22px;
      z-index: +1;

      @include mobile {
        width: 100%;
        font-size: 14px;
        line-height: 18px;
        padding: 0 20px;
        margin-top: 20px;
      }
    }

    .colors-wrapper {
      display: flex;
      margin: 20px 0;
      z-index: +1;

      @include mobile {
        margin: 50px 0;
      }

      .color {
        box-sizing: border-box;
        height: 26px;
        width: 26px;
        border: 3px solid #f2f3f3;
        border-radius: 50%;
        cursor: pointer;

        @include mobile {
          margin: 0 3px;
        }

        span {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }

        &:first-child {
          span {
            background-color: #4a4a4a;
          }
        }

        &:nth-child(2) {
          span {
            background-color: #3dbfcd;
          }
        }

        &:last-child {
          span {
            background-color: #f6cf13;
          }
        }

        &.active {
          border: 4px solid $color9;

          span {
            border: 5px solid #fff;
          }
        }
      }
    }

    .band3d {
      height: 450px;
      width: 450px;
      display: flex;
      z-index: +1;

      @include mobile {
        width: 285px;
        height: 285px;
      }
    }

    .circle1 {
      position: absolute;
      height: 58px;
      width: 58px;
      right: 60px;
      top: -30px;

      @include mobile {
        right: -40px;
        top: 170px;
      }
    }

    .circle2 {
      position: absolute;
      height: 499px;
      width: 499px;
      bottom: -245px;
      right: -250px;

      @include mobile {
        right: -440px;
      }
    }

    .circle-orange {
      height: 375px;
      width: 375px;
      position: absolute;
      top: 190px;
      left: -250px;

      @include mobile {
        height: 285px;
        width: 285px;
      }
    }
  }

  .section4 {
    display: flex;
    justify-items: center;
    align-items: center;
    height: 1000px;
    position: relative;
    margin-bottom: 300px;

    @include mobile {
      height: 750px;
      margin-bottom: 500px;
    }

    .band3d {
      height: 55%;
      width: 55%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: +2;

      @include mobile {
        width: 100px;
        height: 200px;
      }
    }

    .description-card {
      height: 200px;
      width: 352px;
      border: 1px solid $color9;
      border-radius: 3px;
      background-color: #ffffff;
      position: absolute;
      z-index: +2;
      padding: 32px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      @include mobile {
        width: 80%;
        padding: 10px;
        text-align: center;
      }

      &.desc1 {
        box-shadow: -23px 0 0 -9px rgba(231, 231, 231, 0.5);
        top: 50px;
        right: 80px;

        @include mobile {
          top: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }

      &.desc2 {
        box-shadow: 23px 0 0 -9px rgba(231, 231, 231, 0.5);
        bottom: 40px;
        left: 60px;

        @include mobile {
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }

    .big-circle {
      border: 2px solid $color9;
      border-radius: 50%;
      position: absolute;
      background: transparent;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: +1;

      &.outer {
        height: 870px;
        width: 870px;

        @include mobile {
          height: 300px;
          width: 300px;
        }
      }
      &.inner {
        height: 700px;
        width: 700px;

        @include mobile {
          height: 250px;
          width: 250px;
        }
      }
    }

    .small-circles {
      position: relative;
      height: 700px;
      width: 700px;
      margin: 0 auto;
      z-index: 1;

      @include mobile {
        height: 250px;
        width: 250px;
      }

      .circle-blue {
        position: absolute;
        z-index: +2;

        &.circle1 {
          height: 37px;
          width: 37px;
          top: 150px;
          left: 35px;

          @include mobile {
            height: 20px;
            width: 20px;
            top: 50px;
            left: 10px;
          }
        }

        &.circle2 {
          height: 22px;
          width: 22px;
          top: 120px;
          left: 67px;

          @include mobile {
            height: 10px;
            width: 10px;
            top: 35px;
            left: 30px;
          }
        }

        &.circle3 {
          height: 51px;
          width: 51px;
          top: 200px;
          right: 0px;

          @include mobile {
            height: 20px;
            width: 20px;
            top: 70px;
            right: 0px;
          }
        }

        &.circle4 {
          height: 30px;
          width: 30px;
          right: -10px;
          top: 270px;

          @include mobile {
            height: 10px;
            width: 10px;
            right: -3px;
            top: 100px;
          }
        }
      }

      .circle-cyan {
        position: absolute;
        z-index: +2;

        &.circle1,
        &.circle2 {
          height: 46px;
          width: 46px;
          padding: 4px;

          @include mobile {
            width: 20px;
            height: 20px;
          }

          .circle-cyan {
            height: 38px;
            width: 38px;
            border: 5px solid #fff;

            @include mobile {
              height: 12px;
              width: 12px;
              border: 3px solid #fff;
            }
          }
        }

        &.circle1 {
          top: 160px;
          right: 180px;

          @include mobile {
            top: 50px;
            right: 60px;
          }
        }

        &.circle2 {
          bottom: 120px;
          left: 200px;

          @include mobile {
            bottom: 40px;
            left: 65px;
          }
        }
      }
    }

    .circle-light-yellow {
      position: absolute;
      height: 355px;
      width: 355px;
      bottom: -150px;
      right: 0;

      @include mobile {
        height: 200px;
        width: 200px;
        bottom: -330px;
        right: -36px;
      }
    }

    .wave-bottom {
      position: absolute;
      left: -590px;
      bottom: -370px;
      width: 265%;

      @include mobile {
        bottom: -500px;
        width: 1150px;
        left: -400px;
        height: 200px;
      }
    }
  }
}
</style>
